<template>
    
    <v-layout row wrap>
            
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">
               <v-tabs-slider color="orange"></v-tabs-slider>
                    <v-tabs-item href="#tab1" >
                        <v-btn flat class="grey--text">
                            Stammdaten
                        </v-btn>
                    </v-tabs-item>
                    <v-tabs-item href="#tab2">
                        <v-btn flat class="grey--text">
                            Marken & Adressen
                        </v-btn>

                    </v-tabs-item>                      
            </v-tabs-bar>    

            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one v-on:submitted="submitForm"></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>
                <v-tabs-content id="tab2">
                    <div>
                        <keep-alive>
                            <form-two v-on:submitted="submitForm"></form-two>
                        </keep-alive>
                    </div>
                </v-tabs-content> 
            </v-tabs-items>
        </v-tabs>    
              
    </v-layout>
    
</template>

<script>

import formOne from './editFirmen_1.vue';
import formTwo from './editFirmen_2.vue';


export default {
    components: {
        'form-one': formOne,
        'form-two' : formTwo
    },
    data() {
        return {

            id: this.$route.params.id    
        }
    }, 
    
     computed: {
        
         loading: function() {
            return this.$store.getters.loading
        }
    },   
    methods: {
        submitForm: function(fa) {
            this.$store.commit('setMessagebar', false)
            this.$store.dispatch('putFirma', fa).then((response)=>{                
                
                this.$store.dispatch('setFirma', this.id)
                
                this.$router.push('/firmen')
            })
            this.$store.commit('setMessagebar', true)
        },
    },
    
    mounted(){       
                        
        
    },
    
}
</script>

<style>
   
    
</style>



// WEBPACK FOOTER //
// editFirmen.vue?66c6d7dc